import Swiper from "swiper";
import { principalConfig, thumbsConfig } from "../utils/slider-configuration";
import { $Q } from "../utils/query-selector";

export function mountSlider(main) {
  if (!main) return;
  const { dataset: { direction = null, index } } = main;
  let thumbnails;
  let principalClass;
  let mainSlider;

  const typeSlider = {
    "horizontal-outside": () => renderHorizontal(),
    "vertical-left": () => renderVerticalOutside(),
    "vertical-right": () => renderVerticalOutside(),
    "vertical-inside": () => renderVerticalInside(),
    "horizontal-inside": () => renderHorizontalInside(),
  }

  const renderHorizontal = () => {
    /**
     * HORIZONTAL SWIPER SLIDER: media product page
     */
    if ($Q(".horizontal-swipper-thumbs")) thumbnails = new Swiper(".horizontal-swipper-thumbs", thumbsConfig(3, false, "horizontalOutsideBreak"));
    principalClass = ".horizontal-swipper-principal";
  }

  const renderVerticalOutside = () => {
     /**
      * VERTICAL SWIPER SLIDER LEFT OUTSIDE: media product page
    */
     if ($Q(".vertical-outside-swipper-thumbs")) thumbnails = new Swiper(".vertical-outside-swipper-thumbs", thumbsConfig(3, true, "verticalOutsideBreak"));
     principalClass = ".vertical-outside-swipper-principal";
  }

  const renderVerticalInside = () => {
    /**
     * VERTICAL SWIPER SLIDER INSIDE: media product page
     */
    if ($Q(".vertical-inside-swipper-thumbs")) thumbnails = new Swiper(".vertical-inside-swipper-thumbs", thumbsConfig(4, true, "verticalInsideBreak"));
    principalClass = ".vertical-inside-swipper-principal";
  }

  const renderHorizontalInside = () => {
    /**
     * HORIZONTAL SWIPER SLIDER INSIDE: media product page
     */
    if ($Q(".horizontal-inside-swipper-thumbs")) thumbnails = new Swiper(".horizontal-inside-swipper-thumbs", thumbsConfig(4, false, "horizontalInsideBreak"));
    principalClass = ".horizontal-inside-swipper-principal";
  }

  typeSlider[direction]();

  // eslint-disable-next-line no-unused-expressions
  direction && (
    mainSlider = new Swiper(
      principalClass,
      principalConfig(thumbnails, principalClass, index),
    )
  )

  return mainSlider;

  // eslint-disable-next-line no-unused-expressions

}
